/**
 * Register production service worker for shell caching.
 */
export const registerServiceWorker = () => {
  if (typeof window === 'undefined' || !('serviceWorker' in navigator)) {
    return;
  }

  const isDev =
    process.env.NODE_ENV === 'development' || process.env.REACT_APP_ENV === 'development';
  if (isDev) {
    return;
  }

  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/service-worker.js').catch(error => {
      console.warn('Service worker registration failed:', error);
    });
  });
};
